import React from 'react';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

// Import gambar
import Activity1 from '../images/activity-1.jpg';
import Activity2 from '../images/activity-2.jpg';
import Activity3 from '../images/activity-3.jpg';
import Activity4 from '../images/activity-4.jpg';
import Activity5 from '../images/activity-5.jpg';
import Activity6 from '../images/activity-6.jpg';
import Activity7 from '../images/activity-7.jpg';
import SectionHeading from './SectionHeading';

const Activity = () => {
  return (
    <div id="activity" className="bg-gray-50 py-16 md:py-20">
      <section data-aos="zoom-in-down" className="container-app">
        <SectionHeading eyebrow="Dokumentasi" title="Foto Kegiatan" />

        <div className="flex flex-col items-center justify-center">
          <div className="w-full">
            <LightGallery
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
                elementClassNames="grid-container"
                download={false}
            >
              {/* Grid Item */}
              <a href={Activity1} data-lg-size="1400-933" className="grid-item">
                <img alt="img1" src={Activity1} />
              </a>
              <a href={Activity2} data-lg-size="1400-933" className="grid-item">
                <img alt="img2" src={Activity2} />
              </a>
              <a href={Activity3} data-lg-size="1400-933" className="grid-item">
                <img alt="img3" src={Activity3} />
              </a>
              <a href={Activity4} data-lg-size="1400-933" className="grid-item">
                <img alt="img4" src={Activity4} />
              </a>
              <a href={Activity5} data-lg-size="1400-933" className="grid-item">
                <img alt="img5" src={Activity5} />
              </a>
              <a href={Activity6} data-lg-size="1400-933" className="grid-item">
                <img alt="img6" src={Activity6} />
              </a>
              <a href={Activity7} data-lg-size="1400-933" className="grid-item">
                <img alt="img7" src={Activity7} />
              </a>
            </LightGallery>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Activity;
